export default {
  metaTitle: 'Group-Buy Products',
  pageTitle: 'Group-Buy Products',
  radio1: 'Pending Review',
  radio2: 'To start',
  radio3: 'Processing',
  radio4: 'Removed',
  radio5: 'Rejected',
  radio6: 'Expired',
  atime: 'Application time',
  stime: 'Start time',
  placeholder1: 'Listing#',
  placeholder2: 'Sku#',
  placeholder3: 'Product Title',
  btn1: 'Batch Operation',
  btn2: 'Select All',
  btn3: 'Batch Remove',
  btn4: 'Batch Cancel',
  columns1: 'List#',
  columns2: 'Image',
  columns3: 'Title',
  columns4: 'Store',
  columns5: 'Validity period (days)',
  columns6: 'Number for group-on',
  columns7: 'Expected start date',
  columns8: 'Application time',
  columns9: 'Sku number',
  columns10: 'Orders',
  columns11: 'Operation',
  buttonText: 'Price',
  buttonCancle1: 'Remove',
  buttonCancle2: 'Cancel',
  columnSpec1: 'Sku#',
  columnSpec2: 'Title/Spec',
  columnSpec3: 'SalePrice',
  columnSpec4: 'Stock',
  columnSpec5: 'GroupPrice',
  racktitle1: 'Price of group-on', // 原文：Price of group-on   (list#${params.row.listingId})
  racktitle2: 'list#',
  success1: 'Success',
  content1: 'Are you sure you want to cancel',
  content2: 'Are you sure you want to remove',
  content3: 'Are you sure you want to batch remove',
  content4: 'Are you sure you want to batch cancel'
}
